import createVueComponent from '../createVueComponent';

const Target = createVueComponent('TargetIcon', [
  ['circle', { cx: '12', cy: '12', r: '10' }],
  ['circle', { cx: '12', cy: '12', r: '6' }],
  ['circle', { cx: '12', cy: '12', r: '2' }],
]);

export default Target;
